var preset_conditions = [ "Diabetes Mellitus", "High Cholesterol", "Glaucoma", "Anemia", "High Blood Pressure", "Arthritis", "Asthma", "Bronchitis/Emphysema", "Thyroid Disorder", "Cancer (Type)", "Allergies", "Obesity", "Heart Disease", "Kidney Disease", "Migraine Headache", "Acid Reflux" ];
var textInputClasses = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-meclinic-teal focus:ring-meclinic-teal text-sm px-2 py-1";
var deleteButtonClasses = "inline-flex items-center justify-center rounded-md border border-transparent px-3 py-2 text-sm font-medium bg-transparent border-0 p-0 text-rose-600 ml-auto js-remove-medical-history";

function undo_delete_med_hist(e){
  e.preventDefault();
  var id = $( e.currentTarget ).attr("id");
  var row = $("tr#tr-" + id );
  if(row.length > 0){
    $( e.currentTarget ).closest(".undo-delete-alert").remove();
    row.show("slow");
    row.find("input:hidden").val(false);
  }
}

function add_med_hist_alert(id){
  var alert_element = document.createElement("div");
  alert_element.classList.add("undo-delete-alert", "mb-3", "rounded-md", "border", "border-blue-200", "bg-blue-50", "p-4", "text-sm", "text-blue-800");

  var alert_row = document.createElement("div");
  alert_row.classList.add("flex", "items-start", "gap-3");

  var message = document.createElement("div");
  message.classList.add("flex-1");
  message.appendChild(document.createTextNode("A medical history was deleted. "));

  var undo = document.createElement("a");
  undo.href = "#";
  undo.id = id;
  undo.classList.add("js-undo-med-hist-delete", "font-medium", "text-blue-700", "hover:text-blue-900");
  undo.appendChild(document.createTextNode("undo"));

  var closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.classList.add("inline-flex", "shrink-0", "items-center", "justify-center", "rounded-md", "p-1", "text-blue-500", "hover:bg-blue-100", "focus:outline-none", "focus:ring-2", "focus:ring-blue-500");
  closeButton.setAttribute("aria-label", "Close");
  closeButton.innerHTML = "&times;";
  closeButton.addEventListener("click", function() {
    alert_element.remove();
  });

  message.appendChild(undo);
  alert_row.appendChild(message);
  alert_row.appendChild(closeButton);
  alert_element.appendChild(alert_row);

  $(".medical-history-alerts").append(alert_element);
}

function remove_medical_history(e) {
  e.preventDefault();
  var row_el = $( e.currentTarget ).closest("tr");
  var id = new Date().getTime()
  $( e.currentTarget ).next("input:hidden").val("true");
  row_el.hide();
  row_el.attr("id", "tr-" + id);
  add_med_hist_alert(id);
}

function add_medical_history(e) {
  e.preventDefault();
  var id = new Date().getTime();
  var table_row_el = document.createElement('tr');
  var condition_td_el = document.createElement('td');
  var notes_td_el = document.createElement('td');
  var _destroy_td_el = document.createElement('td');

  var condition_input_el = document.createElement('input');
  condition_input_el.type = "text";
  condition_input_el.name = "patient[medical_histories_attributes][" + id + "][condition]";
  condition_input_el.className = textInputClasses + " medical_condition";
  condition_td_el.className = "p-2";
  condition_td_el.appendChild(condition_input_el);

  var notes_input_el = document.createElement('input');
  notes_input_el.type = "text";
  notes_input_el.name = "patient[medical_histories_attributes][" + id + "][notes]";
  notes_input_el.className = textInputClasses;
  notes_td_el.className = "p-2";
  notes_td_el.appendChild(notes_input_el);

  var _destroy_a_el = document.createElement('a');
  var _destroy_a_icon = document.createElement('i')
  var _destroy_a_content = document.createTextNode(" Delete");
  _destroy_a_icon.className = "fa fa-fw fa-trash-o mr-1";
  _destroy_a_el.className = deleteButtonClasses;
  _destroy_a_el.href = "#";
  _destroy_a_el.appendChild(_destroy_a_icon);
  _destroy_a_el.appendChild(_destroy_a_content);

  var _destroy_input_el = document.createElement('input');
  _destroy_input_el.type = "hidden";
  _destroy_input_el.val = "false";
  _destroy_input_el.name = "patient[medical_histories_attributes][" + id + "][_destroy]";
  _destroy_td_el.className = "p-2";
  _destroy_td_el.appendChild(_destroy_a_el);
  _destroy_td_el.appendChild(_destroy_input_el);

  table_row_el.appendChild(condition_td_el);
  table_row_el.appendChild(notes_td_el);
  table_row_el.appendChild(_destroy_td_el);

  $(".js-patient-medical-records tbody").append( table_row_el );
}

$(function(){
  $(".js-patient-medical-records").on("click", ".js-add-medical-history", add_medical_history);
  $(".js-patient-medical-records").on("click", ".js-remove-medical-history", remove_medical_history);
  $(".js-patient-medical-records").on("click", ".js-undo-med-hist-delete", undo_delete_med_hist);

  $(".js-patient-medical-records").on('keydown.autocomplete', ".medical_condition", function() {
    $( this ).autocomplete({ source: preset_conditions });
  });
});
